import api, { STORAGE_KEYS } from './api';

/**
 * استخراج البيانات من الـ API Response
 * الـ Backend يرسل: { success, message, data }
 * الـ api.js يرجع الـ response كامل
 */
const extractData = (response, key) => {
  // response هو الـ JSON مباشرة من api.js
  // التنسيق: { success: true, message: "...", data: { [key]: {...} } }
  if (response?.data?.[key]) {
    return response.data[key];
  }
  // fallback لو الـ data موجودة مباشرة
  if (response?.[key]) {
    return response[key];
  }
  return null;
};

export const statisticsService = {
  /**
   * Get full statistics for statistics page (legacy)
   */
  getStatistics: async (dateRange = 'month', startDate = null, endDate = null) => {
    const params = { dateRange };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    
    const response = await api.get('/user/statistics?' + new URLSearchParams(params));
    return extractData(response, 'statistics') || {};
  },

  /**
   * Get KPIs data
   */
  getKPIs: async (dateRange = 'month') => {
    const response = await api.get('/user/statistics/kpis?dateRange=' + dateRange);
    return extractData(response, 'kpis');
  },

  /**
   * Get offers statistics
   */
  getOffersStats: async () => {
    const response = await api.get('/user/statistics/offers');
    return extractData(response, 'offersStats');
  },

  /**
   * Get requests statistics
   */
  getRequestsStats: async () => {
    const response = await api.get('/user/statistics/requests');
    return extractData(response, 'requestsStats');
  },

  /**
   * Get matching statistics
   */
  getMatchingStats: async () => {
    const response = await api.get('/user/statistics/matching');
    return extractData(response, 'matchingStats');
  },

  /**
   * Get performance chart data
   */
  getPerformanceStats: async (months = 4) => {
    const response = await api.get('/user/statistics/performance?months=' + months);
    return extractData(response, 'performanceData') || [];
  },

  /**
   * Get financial statistics
   */
  getFinancialStats: async (dateRange = 'month') => {
    const response = await api.get('/user/statistics/financial?dateRange=' + dateRange);
    return extractData(response, 'financialStats');
  },

  /**
   * Get network statistics
   */
  getNetworkStats: async () => {
    const response = await api.get('/user/statistics/network');
    return extractData(response, 'networkStats');
  },

  /**
   * Export statistics report
   */
  exportReport: (type, dateRange = {}) => {
    const token = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
    const params = new URLSearchParams();
    
    if (dateRange.startDate) params.append('startDate', dateRange.startDate);
    if (dateRange.endDate) params.append('endDate', dateRange.endDate);
    if (token) params.append('token', token);
    
    const url = `${process.env.REACT_APP_API_URL || 'https://back.miskest.com/api/v1'}/user/statistics/export/${type}?${params.toString()}`;
    window.open(url, '_blank');
  }
};

export default statisticsService;
